module.exports = __webpack_public_path__ + "assets/cdbl-logo.07cb5937.svg";